import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/pig-with-coins.png'


const _withScopeId = n => (_pushScopeId("data-v-51bfac58"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "pricing",
  id: "pricing"
}
const _hoisted_2 = { class: "sell" }
const _hoisted_3 = {
  class: "sell__title",
  delay: 100
}
const _hoisted_4 = {
  class: "sell-profit",
  initial: {
          opacity: 0,
          x: -30
        },
  visibleOnce: {
          opacity: 1,
          x: 0
        },
  delay: 400
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sell-profit__paying" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "paying-item" }, [
    /*#__PURE__*/_createElementVNode("p", null, "You sell a phone case"),
    /*#__PURE__*/_createElementVNode("p", null, "19")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "paying-item" }, [
    /*#__PURE__*/_createElementVNode("p", null, "You pay for its production"),
    /*#__PURE__*/_createElementVNode("p", null, "9")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sell-profit__value" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Your profit"),
  /*#__PURE__*/_createElementVNode("p", null, "10")
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  class: "piggie",
  src: _imports_0,
  alt: "pig with coins",
  delay: 300
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _directive_motion_fade_visible_once = _resolveDirective("motion-fade-visible-once")!
  const _directive_motion = _resolveDirective("motion")!
  const _directive_motion_slide_visible_once_right = _resolveDirective("motion-slide-visible-once-right")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_3, [
        _createTextVNode(" Sell first, pay later with no subscription fees. ")
      ])), [
        [_directive_motion_fade_visible_once]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7)), [
        [_directive_motion]
      ]),
      _withDirectives(_createVNode(_component_Button, {
        black: "",
        link: $setup.CUSTOMIS3D_PROD,
        class: "sell__button",
        text: "Start selling"
      }, null, 8, ["link"]), [
        [_directive_motion_fade_visible_once]
      ])
    ]),
    _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
      [_directive_motion_slide_visible_once_right]
    ])
  ]))
}